import React, { Fragment, useState, useLayoutEffect } from 'react';
import { useMediaQuery, Hidden, NoSsr } from '@material-ui/core';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Grid from '../../../components/molecules/Grid';
import useStyles from './style';
import Picture from '../../../components/atoms/Picture';
import Overlay from '../../../components/atoms/Overlay';
import HeroCarousel from '../../../components/organism/HeroCarousel';
import Button from '../../../components/atoms/Button';
import PrefetchImages from '../../../utils/PrefetchImages';
import { isInsideChina } from '../../../utils/cookie';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import Typography from '../../../components/atoms/Typography';
import DctSvgIcon from '../../../components/atoms/Svg';
import { COMPONENT_NAME } from './locators';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import aspectRatios from '../../../utils/AspectRatios';
import { pageContentType } from '../../../utils/getContentType';
import { getThumbnailFromYoutube, plyrVideo } from '../../../utils/video';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { canUseDOM } from '../../../utils/canUseDOM';
import {
  getPageName,
  getComponentName,
} from '../../../utils/getPageComponentInfo';
import CustomVideo from '../../../components/atoms/Video';


// import { mockMediaGallery } from './__test__/tileData';

const MediaGallery = props => {
  // FOR DISCONNCTED MODE, uncomment this below section and comment out line no. 28
  /*
  const { gallery } = mockMediaGallery; 
  const pageTitle = {
    value: 'Page Title',
  };
   */
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const contentType = pageContentType(props).toLowerCase();
  const siteCoreRoute = get(props, 'sitecoreContext.route', {});
  const { name } = get(siteCoreRoute, 'fields', {});

  const gallery =
    (get(props, 'fields.gallery', '').length > 0 &&
      get(props, 'fields.gallery')) ||
    get(siteCoreRoute, 'fields.gallery', '');

  const [renditionNeeded, setRenditionNeeded] = useState(true);

  // if gallery is empty then using thumbnailImageURL from sitecore context
  // if (gallery && gallery.length === 0) {
  //   const thumbnailImageURL = get(
  //     siteCoreRoute,
  //     'fields.thumbnailImageUrl.value',
  //     ''
  //   );
  //   if (thumbnailImageURL) {
  //     setRenditionNeeded(false);
  //     gallery.push({
  //       fields: {
  //         image: {
  //           value: {
  //             src: thumbnailImageURL,
  //           },
  //         },
  //       },
  //     });
  //   }
  // }
  // we need no-rendition when advanced image object
  // not available
  if (gallery && gallery.length > 0) {
    if (
      renditionNeeded &&
      !gallery.some(
        item =>
          get(item, 'fields.image.value[16x9-m]') ||
          get(item, 'fields.image.value[16x6]')
      )
    ) {
      setRenditionNeeded(false);
    }
  }

  const classes = useStyles({ contentType });
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(`(max-width:${1023}px)`);
  const [isOverlayVisible, setVisibleState] = useState(false);
  const [handleOpenState, setOpenState] = React.useState(false);
  const [handleBtnClickHandler, setHandleBtnClickHandler] = React.useState(
    false
  );
  const [currentSlidePos, setCurrentSlidePos] = useState(1);
  const [buttonIconName, setButtonIconName] = useState('ImageOutlinedIcon');

  useLayoutEffect(() => {
    if (canUseDOM) {
      function setWrapperHeight() {
        let el = document.querySelector('.mediaWrapper');
        if (el) {
          const availWidth = window.innerWidth;
          let minHeight = 0;
          if (availWidth >= breakpoints.values.lg) {
            minHeight = (availWidth * 6) / 16;
          } else {
            minHeight = (availWidth * 9) / 16;
          }
          el.style.minHeight = minHeight - 20 + 'px';
          setTimeout(() => {
            if (el.querySelector('.noRendition')) {
              el.querySelector('.noRendition').style.height = minHeight + 'px';
            }
          }, 0);
        }
      }
      const setHeightWithDebounce = debounce(setWrapperHeight, 500);
      setWrapperHeight();
      window.addEventListener('resize', setHeightWithDebounce);
      return () => window.removeEventListener('resize', setHeightWithDebounce);
    }
  }, []);

  const setIsVisible = isVisible => {
    setVisibleState(isVisible);
    setHandleBtnClickHandler(!isVisible);
    if (!isVisible) {
      // resetting slide count to 1 after closing
      // the overlay
      setCurrentSlidePos(1);
    }
  };

  const addAnalyticsInfo = (isCollageClick = false, video) => {
    let pushData;
    if (isCollageClick) {
      pushData =
        get(video, 'value.href', '') && get(video, 'value.href', '').length > 0
          ? get(analyticsData, 'pageBodyInteraction.galleryVideoClick')
          : get(analyticsData, 'pageBodyInteraction.galleryImageClick');
    } else {
      pushData = get(analyticsData, 'pageBodyInteraction.seeAllPhotosBtnClick');
    }
    const obj = {
      ...pushData,
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          name && name.value,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };

  const setOverlayOpen = (video, id) => {
    addAnalyticsInfo(true, video);
    setVisibleState(true);
    if (isMobile) {
      setHandleBtnClickHandler(true);
    }
    if (Array.prototype.findIndex) {
      setCurrentSlidePos(gallery.findIndex(item => item.id === id) + 1);
    } else {
      const galleryWithIds = gallery.map(item => item.id);
      setCurrentSlidePos(galleryWithIds.indexOf(id) + 1);
    }
  };

  let playerDOMRef = null;
  const setPlayerDOMRef = ref => {
    playerDOMRef = ref;
  };
  React.useEffect(() => {
    if ((!isInsideChina(props.sitecoreContext) && canUseDOM, isMobile)) {
      plyrVideo({
        playerDOMRef: playerDOMRef,
        shouldShowPoster: false,
        handleOpenState: true,
        handleMediaGalleryPlayback: true,
      });
    }
  }, [isMobile]);

  const playVideo = video => {
    const videoHref = get(video, 'value.href', '') || '';
    const hasVideo = videoHref.length > 0;
    setOpenState(hasVideo);
    if (hasVideo && canUseDOM) {
      setHandleBtnClickHandler(true);
      let playBtn = document.querySelector(
        '.slick-active .plyr__control--overlaid'
      );
      let playBtnYouku = document.querySelector('.slick-active .youkuPlayIcon');
      const playBtnInterval = setInterval(() => {
        playBtn = document.querySelector(
          '.slick-active .plyr__control--overlaid'
        );
        playBtnYouku = document.querySelector('.slick-active .youkuPlayIcon');
        if (playBtn || playBtnYouku) {
          clearInterval(playBtnInterval);
          setTimeout(() => {
            setOpenState(false);
            playBtn && playBtn.click();
            playBtnYouku && playBtnYouku.click();
          }, 100);
        }
      }, 100);
    }
  };

  if (gallery && gallery.length === 0) {
    return <></>
  }

  const renderTile = ({
    item: { image, mobileImage, video, youkuVideo },
    ratio = '16x9-m',
    id = 1,
  }) => {
    const videoUrl = isInsideChina(props && props.sitecoreContext)
      ? youkuVideo
      : video;
    return (
      <div
        className={clsx(
          'clickable-item',
          image && image.value && !image.value.src && 'fallBackColor'
        )}
        onClick={(event) => {
          // if event.target closests element has a parent class plyr__control
          if (!(event.target.classList.contains('plyr__control') || event.target.closest('.plyr__control'))) {
            setOverlayOpen(video, id)
          }
        }}
      >
        {(get(videoUrl, 'value.href') || '').length > 0 ? (
          // Create picture tag with play icon for videos featured banner
          // so that page can load faster
          isMobile ? (
            isInsideChina(props.sitecoreContext) ? (
              <div className="picture-with-play-icon">
                <NoSsr>
                  <Button
                    size="medium"
                    iconOnly={true}
                    iconType="outlined"
                    srText="Play"
                    className="playIcon"
                    onClick={() => playVideo(videoUrl, id)}
                  >
                    <DctSvgIcon name="PlayArrowIcon" />
                  </Button>
                </NoSsr>
                {get(image, 'value.src') && (
                  <Picture
                    media={{
                      image,
                      mobileImage,
                      aspectRatio: aspectRatios[ratio],
                      disableLazyLoad: true,
                      renditionNeeded: renditionNeeded,
                    }}
                    alternateAltText={pageName}
                    isParalax={false}
                  />
                )}
              </div>
            ) : (
              <CustomVideo
                video={videoUrl}
                posterImage={image}
                mobileImage={mobileImage}
                aspectRatio={aspectRatios[ratio]}
                setPlayerDOMRef={setPlayerDOMRef}
              />
            )
          ) : (
            <div className="picture-with-play-icon">
              <NoSsr>
                <Button
                  size="medium"
                  iconOnly={true}
                  iconType="outlined"
                  srText="Play"
                  className="playIcon"
                  onClick={() => playVideo(videoUrl)}
                >
                  <DctSvgIcon name="PlayArrowIcon" />
                </Button>
              </NoSsr>
              {get(image, 'value.src') ? (
                <Picture
                  media={{
                    image,
                    mobileImage,
                    aspectRatio: aspectRatios[ratio],
                    disableLazyLoad: true,
                    renditionNeeded: renditionNeeded,
                  }}
                  alternateAltText={pageName}
                  isParalax={false}
                />
              ) : (
                <Picture
                  media={{
                    image: {
                      value: {
                        src: getThumbnailFromYoutube(video.value.href),
                      },
                    },
                    renditionNeeded: false,
                  }}
                  alternateAltText={pageName}
                  isParalax={false}
                />
              )}
            </div>
          )
        ) : (
          <Picture
            media={{
              image,
              mobileImage,
              aspectRatio: aspectRatios[ratio],
              renditionNeeded: renditionNeeded,
              disableLazyLoad: true,
              forcedRatio: '16x6',
            }}
            alternateAltText={pageName}
            isParalax={false}
          />
        )}
      </div>
    );
  };

  const renderTiles = () => {
    let featuredGallery =
      gallery &&
      gallery.length > 0 &&
      gallery.filter(
        ({ fields }) =>
          fields.isFeatured &&
          (fields.isFeatured.value === 'true' || // handling like this because sometimes sitecore sends it in string also
            fields.isFeatured.value === true)
      );
    // set first gallery as featured
    // when author forgot to add any featured images
    if (isEmpty(featuredGallery)) {
      featuredGallery = [gallery[0]];
    }

    // Updating see all button icon on the basis of first featured
    // banner is video or image
    if (
      (get(featuredGallery[0], 'fields.video.value.href') || '').length > 0 &&
      buttonIconName !== 'CameraAltIcon'
    ) {
      setButtonIconName('CameraAltIcon');
    }

    // we have to show first featured gallery
    // when we are rendering mobile version or we have
    // less than 3 featured image
    if (
      isMobile ||
      (featuredGallery &&
        featuredGallery.length > 0 &&
        featuredGallery.length < 3)
    ) {
      return (
        <Grid item xs={12} className="singleFeatureImage">
          {renderTile({
            item: featuredGallery[0].fields,
            ratio: '16x6',
            id: featuredGallery[0].id,
          })}
        </Grid>
      );
    }

    const renderOnlyThreeImage =
      featuredGallery.length >= 3 && featuredGallery.slice(0, 3);
    const [firstTile, ...restTiles] = renderOnlyThreeImage;
    return (
      <Fragment>
        <Grid item xs={12} md={8}>
          {firstTile &&
            renderTile({ item: firstTile.fields, id: firstTile.id })}
        </Grid>
        <Grid item xs={12} md={4}>
          <Grid container>
            {restTiles &&
              restTiles.map((tile, index) => (
                <Grid item className="grid-item" key={index}>
                  <Hidden mdDown implementation="css">
                    {renderTile({ item: tile.fields, id: tile.id })}
                  </Hidden>
                </Grid>
              ))}
          </Grid>
        </Grid>
      </Fragment>
    );
  };

  const getCurrentSlidePos = pos => {
    setCurrentSlidePos(pos);
  };
  const titleNode = (
    <Fragment>
      <Text field={name} />
      <Typography className="slideCount" variant="labelRegular">
        {`${currentSlidePos} / ${gallery.length}`}
      </Typography>
    </Fragment>
  );

  const buttonIcon = <DctSvgIcon name={buttonIconName} />;

  const prefetchImagesMobile = [];
  const prefetchImagesDesktop = [];

  gallery &&
    gallery.length > 0 &&
    gallery.forEach(image => {
      prefetchImagesMobile.push(
        get(image, 'fields.mobileImage.value[3x2]', '')
      );
    });

  gallery &&
    gallery.length > 0 &&
    gallery.forEach(image => {
      prefetchImagesDesktop.push(get(image, 'fields.image.value[3x2]', ''));
    });

  return (
    <>
      {!isEmpty(gallery) && (
        <div className="mediaWrapper">
          <PrefetchImages
            desktopImageArray={prefetchImagesDesktop}
            mobileImageArray={prefetchImagesMobile}
          />
          <div
            className={clsx(classes.root, { singleGallery: gallery.length === 1 })}
            data-locator={COMPONENT_NAME}
          >
            <Grid container>
              {renderTiles()}
              <Button
                component="span"
                buttonType="primary"
                hasBorder={false}
                buttonIcon={buttonIcon}
                srText={getDictionaryText('seeAll')}
                className={`${classes.seeAllBtn} seeAllBtn`}
                onClick={() => setIsVisible(true)}
                animateSettings={{
                  willAnimate: false,
                }}
              >
                <Typography variant="body3">
                  <Text field={{ value: getDictionaryText('seeAll') }} />
                </Typography>
              </Button>
              <Overlay
                title={titleNode}
                withButton={false}
                addAnalyticsInfo={addAnalyticsInfo}
                className={clsx(
                  classes.overlayWrapper,
                  'overlay-wrapper',
                  { hidden: handleOpenState },
                  { 'video-playing': handleOpenState }
                )}
                isVisible={isOverlayVisible}
                setIsVisible={isVisible => setIsVisible(isVisible)}
                enableClickAway={true}
              >
                <HeroCarousel
                  titleText={(name && name.value) || ''}
                  carouselItems={gallery}
                  hasThumbnail
                  isMobile={isMobile}
                  componentName={componentName}
                  pageName={pageName}
                  getCurrentSlidePos={pos => getCurrentSlidePos(pos)}
                  handleOpenState={handleOpenState}
                  shouldShowThumb={handleBtnClickHandler}
                  carouselConfig={{
                    initialSlide: currentSlidePos - 1,
                    fade: true,
                    swipe: true,
                    lazyLoad: false,
                    responsive: [
                      {
                        breakpoint: 1023,
                        settings: {
                          fade: false,
                          swipe: true,
                        },
                      },
                    ],
                  }}
                  isParalax={false}
                />
              </Overlay>
            </Grid>
          </div>
        </div>
      )}</>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(MediaGallery))
);

export { MediaGallery as MediaGalleryComponent };
